import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import {
  MEDICATION_SCHEDULE_PATTERN_PAUSE_URL,
  MEDICATION_SCHEDULE_PATTERN_QUERY_KEY
} from './queryConstants'
import { useInvalidateMedicationQueries } from './useInvalidateMedicationQueries'

type UseMedicationSchedulePatternPauseReturn = {
  pauseMedicationSchedulePattern: (reason: string) => Promise<void>
  isPausingMedicationSchedulePattern: boolean
}

export type UseMedicationSchedulePatternPauseProps = {
  medicationId: string
  onSuccess?: () => void
  onError?: () => void
}

const useMedicationSchedulePatternPause = ({
  medicationId,
  onSuccess,
  onError
}: UseMedicationSchedulePatternPauseProps): UseMedicationSchedulePatternPauseReturn => {
  const invalidateMedicationQueries = useInvalidateMedicationQueries()

  const pauseMedicationSchedulePatternFunction = async (
    reason: string
  ): Promise<unknown> => {
    return postJSON({
      url: MEDICATION_SCHEDULE_PATTERN_PAUSE_URL.replace('{id}', medicationId),
      method: 'PUT',
      json: {
        reason
      }
    })
  }

  const {
    mutateAsync: pauseMedicationSchedulePatternMutation,
    isLoading: isPausingMedicationSchedulePattern
  } = useMutation<unknown, unknown, string, unknown>(
    [MEDICATION_SCHEDULE_PATTERN_QUERY_KEY],
    pauseMedicationSchedulePatternFunction,
    {
      onSuccess: () => {
        invalidateMedicationQueries()
        onSuccess?.()
      },
      onError: () => {
        onError?.()
      }
    }
  )

  const pauseMedicationSchedulePattern = async (
    reason: string
  ): Promise<void> => {
    await pauseMedicationSchedulePatternMutation(reason)
  }

  return {
    pauseMedicationSchedulePattern,
    isPausingMedicationSchedulePattern
  }
}

export default useMedicationSchedulePatternPause
